import React from "react";
import {observer} from "mobx-react-lite";
import {useCsContext} from "../../state/CsInstance";
import styles from "./CompileButton.module.scss";
import {CompileStatus} from "../../state/compileStore";
import DotDotDot from "../DotDotDot/DotDotDot";

export type Props = {
	disabled?: boolean;
};

function CompileButton({disabled}: Props) {
	const {compileStore, testsStore} = useCsContext();
	const hasTests = testsStore.hasTests && testsStore.shouldRunTests;

	// lie to kids so they don't get confused -- compiling = initializing
	const isCompiling = compileStore.compileStatus === CompileStatus.Compiling;

	let compilationDisplayElement: React.JSX.Element;
	if (isCompiling) {
		compilationDisplayElement = (
			<>
				Compiling
				<DotDotDot />
			</>
		);
	} else {
		compilationDisplayElement = <>{"Compile" + (hasTests ? " & Test" : "")}</>;
	}

	return (
		<button
			className={[
				styles.compileButton,
				disabled ? styles.disabled : "",
				isCompiling ? styles.isCompiling : "",
				!isCompiling && hasTests ? styles.hasTests : "",
			].join(" ")}
			id={"compileButton"}
			disabled={isCompiling || disabled}
			onClick={compileStore.attemptToCompileCode.bind(compileStore)}
		>
			{compilationDisplayElement}
		</button>
	);
}

export default observer(CompileButton);
